import { render, staticRenderFns } from "./tablaLiquidacion.vue?vue&type=template&id=a27be4d2&scoped=true"
import script from "./tablaLiquidacion.vue?vue&type=script&lang=js"
export * from "./tablaLiquidacion.vue?vue&type=script&lang=js"
import style0 from "./tablaLiquidacion.vue?vue&type=style&index=0&id=a27be4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27be4d2",
  null
  
)

export default component.exports